
import { useState } from 'react';
import Drawer from 'react-modern-drawer';
import VerifyData from './VerifyData';
import * as XLSX from "xlsx";
import Papa from "papaparse";
import LogHistory from './LogHistory';

export default function LoadCastFile(param: any) {

    let [VerifyDataStatus, setVerifyDataStatus] = useState(false);

    const onCloseDrawer = () => {
        param.LoadCastFileChange();
    }
    const VerifyDataChange = (e: any) => {
        VerifyDataStatus = false;
        setVerifyDataStatus(VerifyDataStatus)
    }
    console.log("LoadCastFile")

    console.log(param)


    let [fileuploadStatus, setfileuploadStatus] = useState(false);
    let [fileToUpload, setfileToUpload] = useState<File | null>(null);

    const [selectedSheet, setSelectedSheet] = useState<string>('');
    const [sheets, setSheets] = useState("");

    const fileupload = (event: any) => {
        const fileName = event.target.files[0];
        console.log(fileName)
        if (fileName) {
            setfileToUpload(fileName);
            setfileuploadStatus(true);
            fileDetail(fileName)
        }
    }



    let [fileHeader, setfileHeader] = useState<any>([]);
    const fileDetail = (event: any) => {

        const file = event;

        console.log(file)
        const fileType = file.name.split('.').pop().toLowerCase();


        if (fileType === "csv") {
            Papa.parse(file, {
                complete: (results: any) => {
                    const header = results.data[0] || [];
                    setfileHeader(header);
                },
                header: false,
            });
            console.log(fileHeader)
        }

        if (fileType === "xls" || fileType === "xlsx") {

            const reader = new FileReader();
            reader.onload = (evt) => {
                const result = evt.target?.result;
                if (result && result instanceof ArrayBuffer) {
                    const data = new Uint8Array(result);
                    const workbook = XLSX.read(data, { type: "array" });
                    const sheetName = workbook.SheetNames[0];
                    setSheets(sheetName)
                    const worksheet = workbook.Sheets[sheetName];
                    const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                    console.log(jsonData)
                    const header = jsonData[0] || [];
                    setfileHeader(header);
                }
            };
            reader.readAsArrayBuffer(file);
            console.log(fileHeader)
        }

    }

    const formatFileSize = (bytes: number): string => {
        if (bytes < 1024) {
            return `${bytes} B`;
        }

        if (bytes < 1024 ** 2) {
            return `${(bytes / 1024).toFixed(2)} KB`;
        }

        if (bytes < 1024 ** 3) {
            return `${(bytes / 1024 ** 2).toFixed(2)} MB`;
        }

        return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
    };


    let [logStatusOpen, setlogStatusOpen] = useState(false);
    const logChange = (e: any) => {
        console.log(e)
        logStatusOpen = false;
        setlogStatusOpen(logStatusOpen)
    }

    return (

        <Drawer open={param.loadCast}
            onClose={onCloseDrawer}
            direction='right'
            className='react-drawer  allowHscroll allowVscroll'
            size={800}>

            <div className="box noBorderRadius noBorder ws-3 pull-right landing full-height-vh">

                <div className="ws-12 box">

                    <div className='ws-12 pm'>
                        <h1 className='ws-10 text-bold'> Load Cast File</h1>
                        <a onClick={() => onCloseDrawer()} className="btn-xxs modalClose borderNone bgTransparent pull-right " style={{ position: "inherit" }}>
                            <i className="icon-close3 danger"></i>
                        </a>

                        <span className='ws-12 ptl'>  Import cast data using a BECS template.<br />  You'll be able to review changes before committing.</span>

                    </div>

                    <div className="ws-12 bg-landing mt mb">

                        <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>
                        <div className="ws-12 pll pt ">
                            <div className='ws-4'>
                                <div className='ws-11'>
                                    <button className="roundedButtons borderNone bg-blue pull-left">1 </button> <span className="step ml"> Load File</span>
                                    <hr className="ws-3 pull-right" style={{ "borderTop": "solid 2px #767779 " }}></hr>
                                </div>
                            </div>

                            <div className='ws-5'>
                                <div className='ws-10'>
                                    <button className="roundedButtons borderNone bg-grey pull-left"> 2 </button> <span className="step disabled ml"> Verify data</span>
                                    <hr className="ws-3 pull-right" style={{ "borderTop": "solid 2px #767779 " }}></hr>
                                </div>
                            </div>

                            <div className='ws-3'>
                                <div className='ws-12'>
                                    <button className="roundedButtons borderNone bg-grey"> 3</button> <span className="step disabled"> Commit</span>
                                </div>
                            </div>

                        </div>

                        <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>
                    </div>

                    <div className='ws-12'>

                        <button className="roundedButtons borderNone bg-blue pull-left mt ml mr">1 </button> <h1 className="step "> Load File</h1>

                        <div className='ws-12 pm'>
                            <label className='ws-12 ps'>
                                <input type="radio" name="source" defaultChecked />
                                Upload file
                            </label>

                            <label className='ws-12 ps'>
                                <input type="radio" name="source" />
                                From URL
                            </label>

                            <label className='ws-12 ps'>
                                <input type="radio" name="source" />
                                From existing template
                            </label>
                        </div>
                    </div>

                    <div className='ws-12 pm'>
                        <div className="dropzone">
                            <button className='btn-xxl ws-12   paddingCenterBox'>  <i className='icon-download paddingCenterBox' /> </button>
                            <p>Drag and drop your <strong>.xlsx</strong> or <strong>.csv</strong> file here,</p>
                            <input className="icon-btn primary bg-level5 white paddingCenterBox hide" />

                            <label className="icon-btn info width190 height40 mt mrl paddingCenterBox" >
                                Choose file
                                <input type="file" accept='pdf/*' key="file" onChange={(e) => fileupload(e)} className="hide" />
                            </label>

                            <p className="hint">.xlsx, .csv up to 20MB</p>
                        </div>

                        <div className='ws-12 pbl'>
                            <button className='borderNone btn-l ws-1 icon-btn info p0 m0'><i className='icon-download1'> </i></button>
                            <span className='pt ws-9 info'>Download BECS Cast Template</span>
                        </div>

                        {fileToUpload && <div className='ws-12 pm bg-info'>
                            {fileToUpload && <div className='ws-12 ps'>
                                <span className='ws-6 text-bold'>FileName : </span>
                                <span className='ws-6 text-normal'>{fileToUpload?.name}</span>
                            </div>}
                            {fileToUpload && <div className='ws-12 ps'>
                                <span className='ws-6 text-bold'>FileSize : </span>
                                <span className='ws-6 text-normal'>{formatFileSize(fileToUpload?.size)}</span>
                            </div>}

                            {fileToUpload && <div className='ws-12 ps'>
                                <span className='ws-6 text-bold'>Sheet Name : </span>
                                <span className='ws-6 text-normal'>{sheets}</span>
                            </div>}

                            {fileToUpload && <div className='ws-12 ps'>
                                <span className='ws-6 text-bold'>File Header :</span>
                                <div className='ws-12 allowHscroll allowVscroll forceSingleLine'>

                                    {fileHeader.map((post: any) => (
                                        <span className='icon-btn info width170 ms'>
                                            {post}
                                        </span>
                                    ))}

                                </div>
                            </div>}


                        </div>}

                    </div>

                    <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>
                    <span className='black pt ws-9 plxl'> {'> '} Need help formatting? </span>
                    <button className='ws-2 borderNone pull-right btn-xl'>
                        <i className='icon-angle-down pull-right'></i>
                    </button>

                    <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                    <div className='ws-12 pm'>
                        <button type="button" className=" icon-btn close text-bold pull-right height40 width100" onClick={() => onCloseDrawer()}>Cancel</button>
                        <button type="button" className=" icon-btn edit text-bold pull-right height40 width100" disabled={!fileuploadStatus} onClick={() => setVerifyDataStatus(true)}>Verify data</button>
                        <button type="button" className=" icon-btn info text-bold pull-left height40 width100" onClick={() => setlogStatusOpen(true)}>Log</button>
                    </div>

                </div>

            </div>

            {
                (() => {
                    if (VerifyDataStatus) {
                        return <VerifyData VerifyDataChange={VerifyDataChange} VerifyDataOpen={VerifyDataStatus} />
                    }

                    if (logStatusOpen) {
                        return <LogHistory logChange={logChange} logStatusOpen={logStatusOpen} />
                    }
                })()
            }
        </Drawer >
    );
}
